import { useEffect, useRef, useState } from "react";
import {
	Asterisco,
	BackgroundProgress,
	ContainerButtons,
	ContainerProgress,
	ContainerQuestionnarie,
	ContainerQuestionsComponent,
	ContainerWelcomeComponent,
	Content,
	FooterICP,
	HeaderICP,
	Progress,
} from "./styles";
import Text from "../../components/Texts/Text";
import { TextsProps } from "../../database/txt.interface";
import { useDispatch, useSelector } from "react-redux";
import { Colors } from "../../styles/colors";
import FormSubmiteButton from "../../components/Buttons/FormSubmitButton";

import { ReactComponent as LogoKinology } from "../../assets/kinologyIcons/svg/logo.svg";
import { ReactComponent as ArrowBack } from "../../assets/kinologyIcons/svg/arrow_back.svg";
import backgroundLogin from "../../assets/kinologyIcons/png/Loginweb.png";

import {
	QuestionnaireProps,
	UserProps,
} from "../../interfaces/pacientes.interface";
import moment from "moment";
import { PacAvalActions } from "../../store/ducks/manage_pac_aval";
import { TypeQuestionnaireProps, TypesErrorRequest } from "../../utils/types";
import {
	Body,
	ContentBody,
	Question,
} from "../Paciente/Questionario_progress/styles";
import DOMParserReact from "dom-parser-react";
import RadioButton from "../Paciente/Questionario_progress/Components/RadioButton";
import TextInput from "../Paciente/Questionario_progress/Components/TextInput";
import { AppActions } from "../../store/ducks/app";
import history from "../../routes/history";
import axios from "axios";
import {
	loadStorage,
	persistStorage,
	removeStorage,
} from "../../utils/base_async_storage";
import { AmplitudeLog } from "../../utils/amplitude";
import { sendErrorSentryOrLocalHost } from "../../utils/funcs";
import { AvaliationActions } from "../../store/ducks/avaliation";
import { AuthActions } from "../../store/ducks/auth";
import { ConfigsActions } from "../../store/ducks/configs";

interface PropsAnswer {
	QUESTIONARIO_LABEL: string;
	QUESTIONARIO_RESPOSTA: string[];
}

const FormularyICP: React.FC = () => {
	const dispatch = useDispatch();
	const hasRegisteredIcpView = useRef(false);

	const current_language: TextsProps = useSelector(
		(state: any) => state.configs.current_language
	);
	const language = useSelector((state: any) => state.configs.language);
	const array_respostas = useSelector(
		(state: any) => state.pac_aval.array_respostas
	);
	const id_user: UserProps = useSelector(
		(state: any) => state.app.id_user_icp_form
	);
	const parameter: "Welcome" | "Home" = useSelector(
		(state: any) => state.app.parameter_route_icp
	);
	const infoLogsNewUser = useSelector(
		(state: any) => state.register.info_ICP_log
	);
	const user_logado: UserProps = useSelector((state: any) => state.auth.user);

	const [steps, setSteps] = useState(0);
	const [load, setLoad] = useState(false);
	const [questionnaireICP, setQuestionnaireICP] = useState<
		QuestionnaireProps[] | []
	>([]);
	const [currentProgress, setCurrentProgress] = useState(0);

	const pacientes = useSelector((state: any) => state.dashboard.pacientes);

	const icpVisualizationsUser = user_logado?.icp?.visualizacao ?? [];

	const showAnswerLaterButton =
		pacientes?.length > 0 && icpVisualizationsUser.length < 3;

	async function getView() {
		const icpVisualizations = Array.isArray(user_logado?.icp?.visualizacao)
			? user_logado.icp.visualizacao
			: [];

		const alreadyShownToday = icpVisualizations.some((item: any) =>
			moment(item.ICP_VISUALIZADO).isSame(moment(), "day")
		);

		if (alreadyShownToday) {
			history.replace("/dashboard");
		}
	}

	useEffect(() => {
		async function hydrateAuth() {
			if (user_logado) return;
			const storedUser = await loadStorage<UserProps>("auth");
			if (storedUser) {
				dispatch(AuthActions.auth_success(storedUser));
			}
		}
		hydrateAuth();
	}, [dispatch, user_logado]);

	useEffect(() => {
		if (!user_logado) return;

		getView();
	}, [user_logado]);

	useEffect(() => {
		const today = moment().format("DD/MM/YYYY");
		persistStorage({
			res: today,
			tag: "icpFormViewed",
		});
	}, []);

	const registerIcpVisualization = () => {
		const icpVisualizations = Array.isArray(user_logado?.icp?.visualizacao)
			? user_logado.icp.visualizacao
			: [];
		const alreadyShownToday = icpVisualizations.some((item: any) =>
			moment(item.ICP_VISUALIZADO).isSame(moment(), "day")
		);

		if (
			pacientes?.length > 0 &&
			icpVisualizations.length < 3 &&
			!alreadyShownToday &&
			!hasRegisteredIcpView.current
		) {
			hasRegisteredIcpView.current = true;
			dispatch(
				ConfigsActions.set_modal_visualization({
					txTipo: "ICP",
					txDataHora: moment().format("YYYY-MM-DD HH:mm:ss"),
					txCategoria: 1,
				})
			);
		}
	};

	useEffect(() => {
		registerIcpVisualization();
	}, [pacientes?.length, user_logado]);

	const nextQuestion = () => {
		if (currentProgress < questionnaireICP?.length - 1) {
			setCurrentProgress((prevState) => prevState + 1);
		}
	};
	const previousQuestion = () => {
		if (currentProgress > 0) {
			setCurrentProgress((prevState) => prevState - 1);
		}
	};

	const checkResponsesValues = (
		questionnaire: QuestionnaireProps[],
		responses: any
	) => {
		const resultado: {
			QUESTIONARIO_LABEL: string;
			QUESTIONARIO_RESPOSTA: any;
		}[] = [];

		questionnaire.forEach((item) => {
			const label = item.QUESTIONARIO_LABEL;
			const resposta = responses[label];
			if (resposta && !(resposta.length === 1 && resposta[0] === "")) {
				resultado.push({
					QUESTIONARIO_LABEL: label,
					QUESTIONARIO_RESPOSTA: resposta,
				});
			}

			if (
				Array.isArray(item.QUESTIONARIO_PERGUNTA_COMPLEMENTO) &&
				item.QUESTIONARIO_PERGUNTA_COMPLEMENTO.length > 0
			) {
				item.QUESTIONARIO_PERGUNTA_COMPLEMENTO.forEach((complemento) => {
					const subLabel = complemento.QUESTIONARIO_LABEL;
					const subResposta = responses[subLabel];
					if (
						subResposta &&
						!(subResposta.length === 1 && subResposta[0] === "")
					) {
						resultado.push({
							QUESTIONARIO_LABEL: subLabel,
							QUESTIONARIO_RESPOSTA: subResposta,
						});
					}
				});
			}
		});
		dispatch(PacAvalActions.set_array_respostas([...resultado]));
		const filteredData = resultado.filter(
			(item) => !item.QUESTIONARIO_LABEL.includes("OUTROS")
		);
		setCurrentProgress(filteredData.length);
	};

	const findAnswerCurrentProgress = () => {
		return array_respostas.find(
			(element: PropsAnswer) =>
				element.QUESTIONARIO_LABEL ==
					questionnaireICP[currentProgress]?.QUESTIONARIO_LABEL &&
				element.QUESTIONARIO_RESPOSTA[0] !== ""
		);
	};

	const hasComplement = () => {
		return questionnaireICP[currentProgress]?.QUESTIONARIO_PERGUNTA_COMPLEMENTO;
	};
	const getValueCurrentComplement = () => {
		let valueComplement;
		const complement = hasComplement();
		if (Array.isArray(complement) && complement.length > 0) {
			valueComplement = array_respostas.find(
				(element: PropsAnswer) =>
					element.QUESTIONARIO_LABEL == complement[0]?.QUESTIONARIO_LABEL &&
					element.QUESTIONARIO_RESPOSTA[0] !== ""
			);
		}
		return valueComplement ?? "";
	};

	const handlerAmplitudeEventLogs = () => {
		type keyLogs = {
			[key: string]: string;
		};

		const EventLog: keyLogs = {
			AREA_ATUACAO: "ICP_clicou_atuacao",
			FUNCIONARIOS_MOVIMENTO: "ICP_qtd_funcionarios",
			CLIENTES_ULTIMO_MES: "ICP_qtd_clientes",
			CHAMA_SEU_CLIENTE: "ICP_tipo_cliente",
			ATUACAO_SEU_CLIENTE: " ICP_formulario_finalizado",
		};
		const PropertyHeader: keyLogs = {
			AREA_ATUACAO: "area_atuacao ",
			FUNCIONARIOS_MOVIMENTO: "qtd_funcionarios ",
			CLIENTES_ULTIMO_MES: " clientes_mes_passado ",
			CHAMA_SEU_CLIENTE: "tipo_cliente ",
			ATUACAO_SEU_CLIENTE: "atuacao_corpo_cliente ",
		};
		const PropertyAnswers: any = {
			0: {
				"0": "Fisioterapeuta",
				"1": "Ed. Fisica",
				"2": "Academico",
				"3": "Medicina",
				"4": "Outros",
			},
			1: {
				"0": "2",
				"1": "+3",
				"2": "+5",
			},
			2: {
				"0": "Não_Iniciou",
				"1": "1-5",
				"2": "6-25",
				"3": "+26",
			},
			3: {
				"0": "Paciente",
				"1": "Atleta profissional",
				"2": "Aluno/Atleta",
				"3": "Outros",
			},
			4: {
				"0": "Melhor desempenho esportivo",
				"1": "Reabilitação de lesões",
				"2": "Melhor postura e alívio de dores",
				"3": "Promoção de saúde do movimento",
				"4": "Emagrecimento e ganho de massa muscular",
				"5": "Reabilitação cardiovascular",
				"6": "Ergonomia",
				"7": "Outros",
			},
		};

		AmplitudeLog(
			EventLog[questionnaireICP[currentProgress]?.QUESTIONARIO_LABEL],
			{
				body: {
					propriedade:
						PropertyHeader[
							questionnaireICP[currentProgress]?.QUESTIONARIO_LABEL
						],
					resposta:
						PropertyAnswers[currentProgress][
							findAnswerCurrentProgress()?.QUESTIONARIO_RESPOSTA[0]
						] +
						(getValueCurrentComplement()
							? `: ${getValueCurrentComplement()?.QUESTIONARIO_RESPOSTA[0]}`
							: ""),
					...(infoLogsNewUser && infoLogsNewUser),
				},
			}
		);
	};

	const handleDisable = () => {
		const checkExistAnswer = findAnswerCurrentProgress();
		const checkValue = array_respostas.find(
			(element: PropsAnswer) =>
				element.QUESTIONARIO_LABEL ==
					questionnaireICP[currentProgress]?.QUESTIONARIO_LABEL &&
				(element.QUESTIONARIO_RESPOSTA[0] !== "" ||
					Number(element.QUESTIONARIO_RESPOSTA[0]) >= 0) &&
				element.QUESTIONARIO_RESPOSTA[0] !==
					questionnaireICP[currentProgress]?.QUESTIONARIO_PERGUNTA_CONDICAO
		);

		const checkComplementValue = array_respostas.find(
			(element: PropsAnswer) =>
				element.QUESTIONARIO_LABEL ==
					questionnaireICP[currentProgress]
						?.QUESTIONARIO_PERGUNTA_COMPLEMENTO![0]?.QUESTIONARIO_LABEL &&
				element.QUESTIONARIO_RESPOSTA[0] !== ""
		);

		if (checkExistAnswer) {
			if (checkValue) {
				return false;
			} else {
				if (checkComplementValue) {
					return false;
				} else {
					return true;
				}
			}
		} else {
			return true;
		}
	};

	async function getQuestionnaireICP() {
		const data_request = {
			txAssincrono: "S",
			txIdioma: language.toLowerCase(),
			txTipo: "ICP",
			ID_USUARIO: id_user,
		};

		async function apiCall() {
			const requestOptions: { method: string; body: string; headers: any } = {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
					Authorization: "Bearer " + user_logado.token,
				},
				body: JSON.stringify(data_request),
			};
			try {
				const data = await fetch(
					`${process.env.REACT_APP_BASE_URL_V7}syncs/questionarios`,
					requestOptions
				);

				const response = await data.json();
				return response;
			} catch (e) {
				sendErrorSentryOrLocalHost(e, {
					message: "Erro ao buscar questionário ICP - getQuestionnaireICP",
					tags: {
						endpoint: "/syncs/questionarios",
						file: "src/pages/FormularyICP/index.tsx",
					},
				});
			}
		}

		try {
			const response: any = await apiCall();
			if (response.status == "success") {
				AmplitudeLog("ICP_formulario_iniciado");
				setLoad(false);
				setSteps(1);
				setQuestionnaireICP(response?.questionario);
				dispatch(PacAvalActions.set_questionario_array(response?.questionario));
				if (parameter !== "Welcome") {
					checkResponsesValues(response?.questionario, response.respostas);
				}
			} else {
				setLoad(false);
				setSteps(0);
			}
		} catch (error) {
			setLoad(false);
		}
	}
	async function saveQuestionnaireICP() {
		setLoad(true);
		const data_request = {
			txDataHora: moment(new Date()).format("YYYY-MM-DD HH:mm:ss").toString(),
			ID_USUARIO: id_user,
			txRespostas: array_respostas,
			ICP_CONCLUIDO: currentProgress == questionnaireICP.length - 1 ? "S" : "N",
		};

		async function apiCall() {
			const config = {
				headers: {
					"Content-Type": "application/json",
					Authorization: "Bearer " + user_logado.token,
				},
			};

			try {
				const URL = `${process.env.REACT_APP_BASE_URL_V7}questionarios/async/salvar_icp`;

				const data = axios.post(URL, data_request, config);

				const response = data;
				return response;
			} catch (e) {
				sendErrorSentryOrLocalHost(e, {
					message: "Erro ao salvar questionario ICP - FormularyICP",
					tags: {
						endpoint:
							window.location.hostname === "localhost"
								? "https://homologacao.api7.kinology.com.br/v7/questionarios/async/salvar_icp"
								: "https://api7.kinology.com.br/v7/questionarios/async/salvar_icp",
						file: "src/pages/FormularyICP/index.tsx",
					},
				});
			}
		}

		try {
			const response: any = await apiCall();
			if (response.data.status == "success") {
				nextQuestion();
				setLoad(false);
				handlerAmplitudeEventLogs();

				if (
					parameter == "Welcome" &&
					currentProgress == questionnaireICP.length - 1
				) {
					history.push("/login");
					dispatch(
						AppActions.set_Modal_Register_Success(
							true,
							current_language?.register_success,
							current_language?.subtitle_modal_register_success
						)
					);
					dispatch(
						AppActions.set_toast_visible({
							status_toast: true,
							type_toast: TypesErrorRequest.SUCCESS,
							message_toast: current_language?.questionario_respondido_success,
						})
					);
					removeStorage();
				} else if (
					parameter !== "Welcome" &&
					currentProgress == questionnaireICP.length - 1
				) {
					dispatch(AvaliationActions.set_show_contract_plans_modal(true));
					history.push("/dashboard");

					dispatch(
						AppActions.set_toast_visible({
							status_toast: true,
							type_toast: TypesErrorRequest.SUCCESS,
							message_toast: current_language?.questionario_respondido_success,
						})
					);
				}
			} else {
				dispatch(
					AppActions.set_toast_visible({
						status_toast: true,
						type_toast: TypesErrorRequest.FAIL,
						message_toast: current_language?.questionario_respondido_failure,
					})
				);
				setLoad(false);
			}
		} catch (error) {
			setLoad(false);
		}
	}

	const WelcomeComponent = () => {
		return (
			<ContainerWelcomeComponent
				style={{
					backgroundImage: `url(${backgroundLogin})`,
					backgroundSize: "cover",
					backgroundPosition: "center",
					width: "100%",
					height: "100vh",
				}}
			>
				<Content>
					<LogoKinology
						color={Colors.secondary_green_k_main}
						width={254}
						height={126.3}
						style={{ alignSelf: "center" }}
					/>

					<Text
						title={
							parameter == "Welcome"
								? current_language?.boas_vindas
								: current_language?.kinology_para_voce
						}
						fontSize={1.758}
						fontFamily="NotoSans-Regular"
						fontWeight={700}
						marginTop={20}
					/>
					<Text
						title={
							parameter == "Welcome"
								? current_language?.inicio_jornada
								: current_language?.experiencia_usuario
						}
						fontSize={1.25}
						fontFamily="NotoSans-Regular"
						marginTop={20}
					/>
					<FooterICP bgColor={steps == 0 ? "transparent" : Colors?.white}>
						<FormSubmiteButton
							onClick={() => {
								getQuestionnaireICP(), setLoad(true);
							}}
							disabled={false}
							activityIndicator={load}
							activityIndicatorColor={Colors?.primary_blue_k_main}
							title={current_language?.continuar_in_modal}
							margintBottom={25}
							fontFamily="Kanit-Regular"
							fontSize={1.25}
							fontWeight={600}
							textColor={Colors.primary_blue_k_main}
							bgColor={Colors.neutral_grey_k_5}
							hoverColor={Colors.neutral_grey_k_5}
							activeColor={Colors.neutral_grey_k_10}
							typeButtonComponent={"primary"}
						/>
						{showAnswerLaterButton ? (
							<div
								onClick={() => {
									history.push("/dashboard");
								}}
								style={{
									display: parameter == "Welcome" ? "none" : "flex",
									justifyContent: "center",
								}}
							>
								<Text
									title={current_language?.responder_mais_tarde}
									fontSize={1.25}
									fontFamily="Kanit-Regular"
									marginBottom={30}
									fontWeight={600}
									cursor="pointer"
								/>
							</div>
						) : null}
					</FooterICP>
				</Content>
			</ContainerWelcomeComponent>
		);
	};

	const ProgressComponent = () => {
		return (
			<ContainerProgress>
				<Text
					title={`${currentProgress + 1}/${questionnaireICP?.length}`}
					fontSize={0.875}
					textColor={Colors?.neutral_grey_k_70}
					fontFamily="NotoSans-Regular"
					textAlign="left"
				/>
				<Progress>
					<BackgroundProgress
						width={currentProgress + 1}
						questionsSize={questionnaireICP?.length}
					/>
				</Progress>
			</ContainerProgress>
		);
	};

	const render_question = (array: any, question: number) => {
		const quest: QuestionnaireProps = array?.find(
			(e: any, i: number) => i === question
		);

		return (
			<>
				<Body>
					{quest?.QUESTIONARIO_PERGUNTA_TIPO !==
						TypeQuestionnaireProps.QUESTIONARIO_PERGUNTA_TIPO.input_text &&
						quest?.QUESTIONARIO_PERGUNTA_TIPO !==
							TypeQuestionnaireProps.QUESTIONARIO_PERGUNTA_TIPO
								.input_checkbox &&
						quest?.QUESTIONARIO_PERGUNTA_TIPO !==
							TypeQuestionnaireProps.QUESTIONARIO_PERGUNTA_TIPO
								.button_upload_arquivo &&
						quest?.QUESTIONARIO_PERGUNTA_TIPO !==
							TypeQuestionnaireProps.QUESTIONARIO_PERGUNTA_TIPO
								.button_nota_adicional &&
						quest?.QUESTIONARIO_PERGUNTA !== null && (
							<Question>
								<DOMParserReact source={quest?.QUESTIONARIO_PERGUNTA} />
								{parameter == "Welcome" && <Asterisco>*</Asterisco>}
							</Question>
						)}

					{quest?.QUESTIONARIO_PERGUNTA_TIPO ===
						TypeQuestionnaireProps.QUESTIONARIO_PERGUNTA_TIPO.radio_button && (
						<RadioButton
							item={quest}
							functionItem={() => null}
							type={"ICP"}
							hasComplement={
								quest?.QUESTIONARIO_PERGUNTA_LINK === "S" ? true : false
							}
						/>
					)}

					{quest?.QUESTIONARIO_PERGUNTA_TIPO ===
						TypeQuestionnaireProps.QUESTIONARIO_PERGUNTA_TIPO.input_text &&
					quest?.QUESTIONARIO_PERGUNTA_LINK !== "S" ? (
						<TextInput item={quest} />
					) : (
						quest?.QUESTIONARIO_PERGUNTA_TIPO ===
							TypeQuestionnaireProps.QUESTIONARIO_PERGUNTA_TIPO.input_text && (
							<Content>
								<ContentBody>
									<Question>
										<DOMParserReact source={quest?.QUESTIONARIO_PERGUNTA} />
									</Question>
									<TextInput item={quest} />
								</ContentBody>
								{quest?.QUESTIONARIO_PERGUNTA_COMPLEMENTO?.map(
									(e: QuestionnaireProps, i: number) => {
										return (
											<ContentBody key={i}>
												<Question>
													<DOMParserReact source={e.QUESTIONARIO_PERGUNTA} />
												</Question>
												<TextInput item={e} />
											</ContentBody>
										);
									}
								)}
							</Content>
						)
					)}
				</Body>
			</>
		);
	};

	return steps == 0 ? (
		WelcomeComponent()
	) : (
		<ContainerQuestionsComponent>
			<HeaderICP>
				<div
					onClick={() => {
						previousQuestion();
					}}
					style={{
						display: currentProgress == 0 ? "none" : "flex",
						position: "absolute",
						alignItems: "center",
						left: 0,
						top: 0,
						cursor: "pointer",
					}}
				>
					<ArrowBack color={Colors?.primary_blue_k_main} />
					<Text
						title={current_language?.voltar}
						fontSize={1}
						textColor={Colors?.primary_blue_k_main}
						fontFamily="NotoSans-Regular"
						fontWeight={700}
						marginLeft={10}
						cursor="pointer"
					/>
				</div>
				<Text
					title={
						parameter == "Welcome" ? current_language?.boas_vindas : "Kinology"
					}
					fontSize={1.5}
					textColor={Colors?.primary_blue_k_main}
					fontFamily="NotoSans-Regular"
					fontWeight={700}
					marginTop={10}
				/>
			</HeaderICP>
			{questionnaireICP.length > 0 && ProgressComponent()}
			<ContainerQuestionnarie>
				{render_question(questionnaireICP, currentProgress)}
			</ContainerQuestionnarie>

			<div
				style={{
					width: "50%",
					display: parameter == "Welcome" ? "flex" : "none",
				}}
			>
				<Text
					title={current_language?.pergunta_obrigatoria}
					fontSize={1}
					textColor={Colors?.tertirary_red_2_dark}
					fontFamily="NotoSans-Regular"
					textAlign="left"
					marginTop={50}
					marginBottom={30}
				/>
			</div>
			<ContainerButtons>
				{/* <FormSubmiteButton
					onClick={() => {
						parameter == "Welcome"
							? previousQuestion()
							: history.push("/dashboard");
					}}
					title={
						parameter == "Welcome"
							? current_language?.voltar
							: current_language?.responder_mais_tarde
					}
					disabled={currentProgress == 0 && parameter == "Welcome"}
					width={48}
					margintBottom={25}
					fontFamily="Kanit-Regular"
					fontSize={1.25}
					fontWeight={600}
					textColor={Colors.primary_blue_k_main}
					bgColor={Colors.neutral_grey_k_5}
					typeButtonComponent={"secondary"}
				/> */}
				<FormSubmiteButton
					onClick={() => {
						saveQuestionnaireICP();
					}}
					disabled={handleDisable()}
					activityIndicator={load}
					activityIndicatorColor={Colors?.neutral_grey_k_5}
					title={
						currentProgress + 1 == questionnaireICP?.length
							? current_language?.execucao_finalizar
							: current_language?.proximo_button
					}
					width={48}
					margintBottom={25}
					fontFamily="Kanit-Regular"
					fontSize={1.25}
					fontWeight={600}
					textColor={Colors.neutral_grey_k_5}
					bgColor={Colors.primary_blue_k_main}
					typeButtonComponent={"primary"}
				/>
			</ContainerButtons>
		</ContainerQuestionsComponent>
	);
};
export default FormularyICP;
